import { render } from "./BaseFilePreviewModal.vue?vue&type=template&id=36244618&scoped=true"
import script from "./BaseFilePreviewModal.vue?vue&type=script&lang=js"
export * from "./BaseFilePreviewModal.vue?vue&type=script&lang=js"

import "./BaseFilePreviewModal.vue?vue&type=style&index=0&id=36244618&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36244618"]])

export default __exports__